function toggleDirA() {
  document.getElementById('gb-directions-dirA').style.setProperty("display", "block", "important");
  document.getElementById('gb-directions-dirB').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirC').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirD').style.setProperty("display", "none", "important");
}

function toggleDirB() {
  document.getElementById('gb-directions-dirA').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirB').style.setProperty("display", "block", "important");
  document.getElementById('gb-directions-dirC').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirD').style.setProperty("display", "none", "important");  
}
  
function toggleDirC() {
  document.getElementById('gb-directions-dirA').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirB').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirC').style.setProperty("display", "block", "important");
  document.getElementById('gb-directions-dirD').style.setProperty("display", "none", "important");  
}

function toggleDirD() {
  document.getElementById('gb-directions-dirA').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirB').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirC').style.setProperty("display", "none", "important");
  document.getElementById('gb-directions-dirD').style.setProperty("display", "block", "important");
}
